import {Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiCacheService {
  // tslint:disable-next-line:no-any
  private cache: Map<string, { data: any; timestamp: number }> = new Map();

  private ttl = 60 * 60 * 1000; // 60 minutes

  isValid(key: string): boolean {
    const entry = this.cache.get(key);
    return entry ? (Date.now() - entry.timestamp) < this.ttl : false;
  }

  get<T>(key: string): T | null {
    return this.isValid(key) ? this.cache.get(key)?.data : null;
  }

  set<T>(key: string, data: T): void {
    this.cache.set(key, { data, timestamp: Date.now() });
  }

  clear(key: string): void {
    this.cache.delete(key);
  }

  clearAll(): void {
    this.cache.clear();
  }
}
